import { Component, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ContentState } from '../../../store/state/content.state';
import { Subject } from 'rxjs';
import { SALES_URL } from '../../../app.constants';
import { Title } from '@angular/platform-browser';
import { setTitleComponent } from 'src/app/utils/titles.util';

@Component({
    selector: 'u4-cpp-sales',
    templateUrl: './sales.component.html',
    styleUrls: ['./sales.component.scss'],
})
export class SalesComponent implements OnDestroy {

    public labels: {[key: string]: string};
    public redirectUrl = SALES_URL;
    private destroy$: Subject<void> = new Subject<void>();

    constructor(private store: Store<ContentState>, private titleService: Title) {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => {
            this.labels = labels;
            this.titleService.setTitle(setTitleComponent(this.labels['sales.title']));
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
